var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('q-btn-toggle',{attrs:{"toggle-color":"primary","options":[
      {label: 'One', value: 'one'},
      {label: 'Two', value: 'two'} ]},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }